if (!customElements.get('error-popup')) {
  class ErrorPopup extends HTMLElement {
    constructor() {
      super();

      this.message = this.querySelector('[data-message]');

      this.addEventListener('click', () => {
        clearTimeout(this.visibilityTimeout);
        this.classList.remove('is-visible');
      });
    }

    showPopup(message, visibilityDuration = 3) {
      clearTimeout(this.visibilityTimeout);

      this.message.textContent = message;
      this.classList.add('is-visible');

      this.visibilityTimeout = setTimeout(() => {
        this.classList.remove('is-visible');
      }, visibilityDuration * 1000);
    }
  }

  customElements.define('error-popup', ErrorPopup);
}
